(function ($) {
	const ajaxUrl = "/wp-admin/admin-ajax.php";

	const MODE = Object.freeze({
		START_WITH_SETTING: "START_WITH_SETTING",
		START_WITH_STONE: "START_WITH_STONE",
	});

	// One request does the whole tray/cart cleanup server-side
	// (see TTG\Build_Ring\Controller::start_design) — separate parallel
	// calls used to leave the tray and the cart out of sync.
	function startDesign(mode, parent) {
		parent.addClass("loading");
		jQuery.ajax({
			url: ajaxUrl + "?action=start_design&mode=" + mode,
			dataType: "json",
			success: function (response) {
				if (response && response.isSuccess) {
					window.location.href = "/build-ring/";
					return;
				}
				parent.removeClass("loading");
			},
			error: function () {
				parent.removeClass("loading");
			},
		});
	}

	$("#start-with-a-stone").on("click", function (e) {
		e.preventDefault();
		startDesign(MODE.START_WITH_STONE, $(this).closest(".build-ring-selection"));
	});

	$("#start-with-a-setting").on("click", function (e) {
		e.preventDefault();
		startDesign(MODE.START_WITH_SETTING, $(this).closest(".build-ring-selection"));
	});
})(jQuery);
